exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-action[data-v-4fec6646] {\n  background-color: #efefef;\n  border-right: 1px solid #ddd;\n  font-size: 1.2rem;\n}\n", ""]);

// exports
